import React from "react";

export default function MonitorIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.53846C9.81823 3.53846 6.83216 3.73771 4.98341 3.87978C4.38263 3.92595 3.91003 4.39142 3.85543 4.98718C3.71478 6.52149 3.53846 8.78459 3.53846 10.4615C3.53846 12.1385 3.71478 14.4016 3.85543 15.9359C3.91003 16.5317 4.38263 16.9971 4.98341 17.0433C6.83216 17.1854 9.81823 17.3846 12 17.3846C14.1818 17.3846 17.1678 17.1854 19.0166 17.0433C19.6174 16.9971 20.09 16.5317 20.1446 15.9359C20.2852 14.4016 20.4615 12.1385 20.4615 10.4615C20.4615 8.78459 20.2852 6.52149 20.1446 4.98718C20.09 4.39142 19.6174 3.92595 19.0166 3.87978C17.1678 3.73771 14.1818 3.53846 12 3.53846ZM4.86553 2.34584C6.715 2.20371 9.75334 2 12 2C14.2467 2 17.285 2.20371 19.1345 2.34584C20.4791 2.44917 21.5531 3.49951 21.6766 4.84675C21.8175 6.38385 22 8.70808 22 10.4615C22 12.215 21.8175 14.5392 21.6766 16.0763C21.5531 17.4236 20.4791 18.4739 19.1345 18.5772C17.285 18.7194 14.2467 18.9231 12 18.9231C9.75334 18.9231 6.715 18.7194 4.86553 18.5772C3.52091 18.4739 2.44688 17.4236 2.32339 16.0763C2.18249 14.5392 2 12.215 2 10.4615C2 8.70808 2.18249 6.38385 2.32339 4.84675C2.44688 3.49951 3.52091 2.44917 4.86553 2.34584Z"
        fill="#A6B0CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6465 7.35351C16.9469 7.65391 16.9469 8.14096 16.6465 8.44136L13.5696 11.5183C13.2692 11.8187 12.7821 11.8187 12.4817 11.5183L10.9744 10.0109L8.44136 12.5439C8.14096 12.8443 7.65391 12.8443 7.35351 12.5439C7.0531 12.2435 7.0531 11.7565 7.35351 11.4561L10.4304 8.37915C10.7308 8.07875 11.2179 8.07875 11.5183 8.37915L13.0256 9.8865L15.5586 7.35351C15.859 7.0531 16.3461 7.0531 16.6465 7.35351Z"
        fill="#A6B0CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.12821 21.2308C7.12821 20.8059 7.4726 20.4615 7.89744 20.4615H16.1026C16.5274 20.4615 16.8718 20.8059 16.8718 21.2308C16.8718 21.6556 16.5274 22 16.1026 22H7.89744C7.4726 22 7.12821 21.6556 7.12821 21.2308Z"
        fill="#A6B0CF"
      />
    </svg>
  );
}
